import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as NotificationsSelectors } from 'data/notifications'
import { List, InfiniteLoader, AutoSizer } from 'react-virtualized'

import fetchesNotifications from './dataSync/fetchesNotifications'
import acknowledgeAllNotifications from 'components/Notifications/dataSync/acknowledgeAll'

import NotificationRow from 'screens/NotificationsRow/Row'

const ROW_HEIGHT = 67

export class NotificationCenterList extends Component {
  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
  }

  render() {
    const { listState } = this.props

    const isEmpty = listState.totalCount === 0
    const isLoaded = listState.totalCount != null && !isEmpty
    return (
      <div className="width-full height-full">
        {isLoaded && (
          <InfiniteLoader
            isRowLoaded={this.isRowLoaded}
            loadMoreRows={listState.loading ? () => {} : this.loadMoreRows}
            rowCount={listState.totalCount}
            threshold={60}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    className="no-outline "
                    style={{ paddingBottom: 300 }}
                    height={height}
                    width={width}
                    onRowsRendered={onRowsRendered}
                    ref={registerChild}
                    rowCount={listState.totalCount}
                    rowRenderer={this.rowRenderer}
                    overscanRowCount={0}
                    rowHeight={ROW_HEIGHT}
                  />
                )}
              </AutoSizer>
            )}
          </InfiniteLoader>
        )}
      </div>
    )
  }

  rowRenderer = ({ index, key, style }) => {
    return (
      <div
        key={key}
        style={{ ...style, left: 0, right: 0 }}
        className="notification-center-item"
      >
        <NotificationRow
          notificationIndex={index}
          className="padding-medium background-shade-100 margin-left-auto margin-right-auto"
          onClick={this.props.onClickRow}
        />
      </div>
    )
  }

  isRowLoaded = ({ index }) => {
    return index < this.props.notificationIds.length
  }

  loadMoreRows = () => {
    const { fetchNextPage, listState } = this.props
    if (!listState.pageInfo.hasNextPage || listState.loading) {
      return
    }
    fetchNextPage()
  }
}

export default compose(
  fetchesNotifications(), // provides fetchNextPage prop
  acknowledgeAllNotifications(), // provides acknowledgeAllNotifications prop
  connect(state => ({
    notificationIds: NotificationsSelectors.getAllNotificationIds(state),
    listState: NotificationsSelectors.getAllNotificationsListState(state),
  }))
)(NotificationCenterList)
